import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { ApolloProvider } from 'react-apollo'
import { ApolloClient, InMemoryCache } from 'apollo-boost'
import { ApolloLink, from } from 'apollo-link'
import { onError } from 'apollo-link-error'
import { createHttpLink } from 'apollo-link-http'
import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Navigation from './Navigation'
import Overview from './Overview'
import Login from './Login'
import Users from './Users/Users'
import Beacons from './Beacons/Beacons'
import Manufacturers from './Manufacturers/Manufacturers'
import Models from './Models/Models'
import Templates from './Templates/Templates'
import Pages from './Pages/Pages'
import NoMatch from './NoMatch'
import withAuthentication from './Users/withAuthentication'
import Loading from './Loading'

import env from '../constants/env'
import routes from '../constants/routes'
import '../utils/strings'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`

const App = ({loaded, token, refreshToken}) => {
  if (!loaded) return <Loading />

  const withToken = new ApolloLink((operation, forward) => {
    operation.setContext({headers: {Authorization: token ? `Bearer ${token}` : ''}})
    return forward(operation)
  })

  const resetToken = onError((errorHandler) => {
    // if server returns `refresh-token` then check for new token, if it changed then withAuthentication
    // will update its state with the new token forcing this component to re-render and ApolloLink to
    // re-initialize with the new token
    if (errorHandler && errorHandler.graphQLErrors && errorHandler.graphQLErrors[0].message === 'refresh-token') refreshToken()
  })

  const authFlow = withToken.concat(resetToken)
  const httpLink = createHttpLink({uri: env.graphql.endpoint})

  const client = new ApolloClient({
    link: from([authFlow, httpLink]),
    cache: new InMemoryCache(),
    connectToDevTools: true
  })

  return (
    <ApolloProvider client={client}>
      <Router>
        <Wrapper>
          <Navigation />
          <Switch>
            <Route exact path={routes.LOGIN} component={Login} />
            <Route exact path={routes.HOME} component={Overview} />
            <Route path={routes.USERS} component={Users} />
            <Route path={routes.BEACONS} component={Beacons} />
            <Route path={routes.MANUFACTURERS} component={Manufacturers} />
            <Route path={routes.MODELS} component={Models} />
            <Route path={routes.TEMPLATES} component={Templates} />
            <Route path={routes.PAGES} component={Pages} />
            <Route component={NoMatch} />
          </Switch>
          <ToastContainer />
        </Wrapper>
      </Router>
    </ApolloProvider>
  )
}

export default withAuthentication(App)


// WEBPACK FOOTER //
// ./src/components/App.js